"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _ReviewPass = _interopRequireDefault(require("@rsuite/icon-font/lib/flow/ReviewPass"));

// Generated by script, don't edit it please.
var ReviewPass = (0, _createSvgIcon["default"])({
  as: _ReviewPass["default"],
  ariaLabel: 'review pass',
  category: 'flow',
  displayName: 'ReviewPass'
});
var _default = ReviewPass;
exports["default"] = _default;
module.exports = exports.default;